<template>
  <div class="wg-row">
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Company name", "Nome azienda") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="content.name"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Email", "Email") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="content.email"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Email 2", "Email 2") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="content.email2"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Email 3", "Email 3") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="content.email3"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Phone 1", "Telefono 1") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <select
              class="com-anm22-app-select"
              v-model="content.phoneAreaCode"
            >
              <option
                v-for="(
                  obj, key, index
                ) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCode-' + index"
                :value="key"
              >
                {{ obj[lang] }}
              </option>
            </select>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
              v-model="content.phoneNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Phone 2", "Telefono 2") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <select
              class="com-anm22-app-select"
              v-model="content.phoneAreaCode2"
            >
              <option
                v-for="(
                  obj, key, index
                ) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCode-' + index"
                :value="key"
              >
                {{ obj[lang] }}
              </option>
            </select>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
              v-model="content.phoneNumber2"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Phone 3", "Telefono 3") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <select
              class="com-anm22-app-select"
              v-model="content.phoneAreaCode3"
            >
              <option
                v-for="(
                  obj, key, index
                ) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCode-' + index"
                :value="key"
              >
                {{ obj[lang] }}
              </option>
            </select>
          </div>
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
              v-model="content.phoneNumber3"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Website", "Sito web") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="com-anm22-app-input-text"
            type="text"
            v-model="content.website"
            data-cy=costumer-details-web-site-input
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Address (Place)", "Indirizzo (Sede)") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-8 wg-sm-8" style="max-width: 200px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
              v-model="content.addressStreet"
              data-cy=costumer-details-street-input
            />
          </div>
          <div class="wg-col wg-xs-4 wg-sm-4" style="max-width: 100px">
            <input
              class="com-anm22-app-input-text"
              type="text"
              placeholder="N."
              v-model="content.addressNumber"
              data-cy=costumer-details-address-number-input
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "City", "Città") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'City', 'Città')"
            v-model="content.addressCity"
            data-cy=costumer-details-city-name-input
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "ZIP", "CAP") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
            v-model="content.addressZip"
            data-cy=costumer-details-zip-code-input
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{
            $anm22.strLang(lang, "State (Abbreviation)", "Provincia (Sigla)")
          }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="
              $anm22.strLang(lang, 'State (Abbreviation)', 'Provincia (Sigla)')
            "
            v-model="content.addressState"
            data-cy=costumer-details-city-abbreviation-input
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="align-items: center">
      <div class="wg-col wg-xs-12 wg-sm-4">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Country", "Paese") }}
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div class="wg-row input-row">
          <select
            class="input-elem com-anm22-app-select"
            v-model="content.addressCountry" data-cy=costumer-details-country-select
          >
            <option value selected disabled hidden>
              {{ $anm22.strLang(lang, "Select", "Seleziona") }}
            </option>
            <option
              v-for="obj in Object.values(
                $anm22.tableClasses.worldCountry().getAll()
              ).sort((a, b) =>
                a[lang] < b[lang] ? -1 : b[lang] > b[lang] ? 1 : 0
              )"
              :key="'country-' + obj.typeClassLiteral"
              :value="obj.typeClassLiteral"
            >
              {{ obj[lang] }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
export default {
  props: {
    contact: Object,
    // value: Object
  },
  data() {
    return {
      content: {}
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline
    }),
  },
  methods: {
    // update: _.debounce(function(value) {
    //   console.log(value);
    //   this.$emit('input', value);
    // }, 500)
  },
  created() {
    // Popolo value a partire dal contatto
    const init = {
      name: "",
      email: "",
      email2: "",
      email3: "",
      website: "",
      phoneAreaCode: "",
      phoneAreaCode2: "",
      phoneAreaCode3: "",
      phoneNumber: "",
      phoneNumber2: "",
      phoneNumber3: "",
      addressStreet: "",
      addressNumber: "",
      addressCity: "",
      addressZip: "",
      addressState: "",
      addressCountry: "",
      // Ids
      customerId: "",
      beachId: "",
      workId: ""
    };
    /* Nome azienda*/
    if (this.contact.type == 2) {
      init.name = this.contact.firstName;
    } else {
      init.name = this.contact.company;
    }
    /* Id spiaggia */
    if (
      this.contact.otherInformations.beachTabs &&
      this.contact.otherInformations.beachTabs.length > 0
    ) {
      init.beachId = this.contact.otherInformations.beachTabs[0];
    }
    if (this.contact.email && this.contact.email != "") {
      init.email = this.contact.email;
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.emails &&
      this.contact.otherContacts.emails[0] &&
      this.contact.otherContacts.emails[0]["address"] &&
      this.contact.otherContacts.emails[0]["address"] != ""
    ) {
      init.email2 = this.contact.otherContacts.emails[0]["address"];
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.emails &&
      this.contact.otherContacts.emails[1] &&
      this.contact.otherContacts.emails[1]["address"] &&
      this.contact.otherContacts.emails[1]["address"] != ""
    ) {
      init.email3 = this.contact.otherContacts.emails[1]["address"];
    }
    if (
      this.contact.phoneAreaCode &&
      this.contact.phoneAreaCode != "" &&
      this.contact.phoneNumber &&
      this.contact.phoneNumber != ""
    ) {
      init.phoneAreaCode = this.contact.phoneAreaCode;
      init.phoneNumber = this.contact.phoneNumber;
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.phones &&
      this.contact.otherContacts.phones[0] &&
      this.contact.otherContacts.phones[0]["phoneAreaCode"] &&
      this.contact.otherContacts.phones[0]["phoneAreaCode"] != "" &&
      this.contact.otherContacts.phones[0]["phoneNumber"] &&
      this.contact.otherContacts.phones[0]["phoneNumber"] != ""
    ) {
      init.phoneAreaCode2 = this.contact.otherContacts.phones[0][
        "phoneAreaCode"
      ];
      init.phoneNumber2 = this.contact.otherContacts.phones[0][
        "phoneNumber"
      ];
    }
    if (
      this.contact.otherContacts &&
      this.contact.otherContacts.phones &&
      this.contact.otherContacts.phones[1] &&
      this.contact.otherContacts.phones[1]["phoneAreaCode"] &&
      this.contact.otherContacts.phones[1]["phoneAreaCode"] != "" &&
      this.contact.otherContacts.phones[1]["phoneNumber"] &&
      this.contact.otherContacts.phones[1]["phoneNumber"] != ""
    ) {
      init.phoneAreaCode3 = this.contact.otherContacts.phones[1][
        "phoneAreaCode"
      ];
      init.phoneNumber3 = this.contact.otherContacts.phones[1][
        "phoneNumber"
      ];
    }
    if (this.contact.website) {
      init.website = this.contact.website;
    }
    if (this.contact.otherInformations.addressStreet) {
      init.addressStreet = this.contact.otherInformations.addressStreet;
    }
    if (this.contact.otherInformations.addressNumber) {
      init.addressNumber = this.contact.otherInformations.addressNumber;
    }
    if (this.contact.otherInformations.addressCity) {
      init.addressCity = this.contact.otherInformations.addressCity;
    }
    if (this.contact.otherInformations.addressZip) {
      init.addressZip = this.contact.otherInformations.addressZip;
    }
    if (this.contact.otherInformations.addressState) {
      init.addressState = this.contact.otherInformations.addressState;
    }
    if (this.contact.otherInformations.addressCountry) {
      init.addressCountry = this.contact.otherInformations.addressCountry;
    }
    if (!init.addressCountry || init.addressCountry == "") {
      init.addressCountry = "it";
    }
    if (!init.phoneAreaCode || init.phoneAreaCode == "") {
      init.phoneAreaCode = "+39";
    }
    if (!init.phoneAreaCode2 || init.phoneAreaCode2 == "") {
      init.phoneAreaCode2 = "+39";
    }
    if (!init.phoneAreaCode3 || init.phoneAreaCode3 == "") {
      init.phoneAreaCode3 = "+39";
    }
    this.content = init;
  },
  watch: {
    content: {
      deep: true,
      handler: _.debounce(function(newValue) {
        this.$emit('input', newValue);
      }, 500)
    }
  }
};
</script>
 
<style lang="scss" scoped>
.add {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  margin-left: 4px;
  cursor: pointer;
}
.input-row {
  padding: 0 5px;
  margin-bottom: 5px;
  align-items: center;
}
// .input-elem {

// }
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.detail-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 10px;

  & img {
    margin: 0 30px 0 10px;
  }
}
</style>
 